import { simple$http } from './index';

/**
 * 获取公钥
 */
export function getRSAPublicKey(clientId = '') {
    return simple$http.get(`/md/encrypt/getRSAPublicKey?clientId=${clientId}`);
}

/**
 * 获取AES密钥
 * @param {*} data : {
 * clientId: '',
 * data: '' // 前端加密后的数据
 * }
 * @returns
 */
export function getAESKey(data) {
    return simple$http.post('/md/encrypt/getAESKey', data);
}
